const GET_STATISTIC = 'HOME_GET_STATISTIC';
const GET_JLLIST = 'GET_JLLIST';

export {
  GET_STATISTIC,
  GET_JLLIST
};
